// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2llm2","text":"SelectPayment_text__2KXCr","title":"SelectPayment_title__1H-d9","btn":"SelectPayment_btn__wnhM-"};